import { render } from "./HomeInform.vue?vue&type=template&id=2242c436&scoped=true"
import script from "./HomeInform.vue?vue&type=script&lang=js"
export * from "./HomeInform.vue?vue&type=script&lang=js"

import "./HomeInform.vue?vue&type=style&index=0&id=2242c436&lang=scss&scoped=true"
import "./HomeInform.vue?vue&type=style&index=1&id=2242c436&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2242c436"]])

export default __exports__